import styled from 'styled-components';
import { Box, palette, radius, fontSize, Heading } from '@landr/maestro';

export const Card = styled(Box)`
    position: relative;
    width: 100%;
    max-height: 192px;

    ${({ theme }): string => theme.breakpoint('lg')`
        max-height: 160px;
    `}

    &::before {
        content: '';
        display: block;
        padding-top: 100%;
    }
`;

export const Content = styled(Box)`
    margin: auto;
    width: 55%;
    height: 55%;

    ${({ theme }): string => theme.breakpoint('lg')`
        width: 66%;
        height: 66%;
    `}
`;

export const Container = styled(Box)`
    display: flex;
    align-items: center;

    border: 2px solid ${palette('neutral.900')};
    border-radius: ${radius('base')};
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    ${Content} svg {
        width: 100%;
        height: 100%;
    }

    ${Content} g,
    ${Content} path {
        stroke-width: 0.75;
    }

    &:hover {
        cursor: pointer;
        background-color: ${palette('neutral.900')};
        ${Content} svg {
            color: ${palette('primary.500')};
        }
    }
`;

export const ResponsiveText = styled(Heading)`
    font-size: ${fontSize('lg')};

    ${({ theme }): string => theme.breakpoint('ms')`
        font-size: 3vw;
    `}

    ${({ theme }): string => theme.breakpoint('sm')`
        font-size:  ${fontSize('md')};
    `}
`;
